/*
 * Última interação do usuário com a tela (clique ou tecla), para o servidor separar a requisição feita pelo usuário
 * da requisição automática (consulta das notificações, atualização automática da gestora e das telas do Administrativo).
 * Requisição sem interação nos últimos segundos é automática: atualiza a última atividade na consulta de usuários
 * conectados (a aba está aberta), mas não a última ação do usuário.
 * Ver a spec documentos/specs/2026-10-16-usuarios-conectados.md
 */

//Tempo depois do clique ou da tecla em que a requisição ainda é do usuário (a ação pode fazer várias requisições seguidas)
export const SEGUNDOS_INTERACAO_USUARIO = 30;

//Hora da última interação (ao abrir a página conta como interação: o usuário acabou de entrar ou recarregar)
let dataUltimaInteracao = Date.now();

//Anota a interação
function registrarInteracao() {
  dataUltimaInteracao = Date.now();
}

//Escuta o clique e a tecla em toda a página (capture: anota antes da tela tratar o evento; passive: não interfere nele)
if (typeof window != "undefined") {
  window.addEventListener("pointerdown", registrarInteracao, {
    capture: true,
    passive: true,
  });
  window.addEventListener("keydown", registrarInteracao, {
    capture: true,
    passive: true,
  });
}

//Retorna se a requisição feita agora é automática (sem interação do usuário nos últimos segundos)
export function fn_isRequisicaoAutomatica(agora = Date.now()) {
  return agora - dataUltimaInteracao > SEGUNDOS_INTERACAO_USUARIO * 1000;
}
